export enum CheckState {
    OK = 'OK', FAILED = 'FAILED', WARN = 'WARN'
}
